import { render } from "./WorkloadPreApprove.vue?vue&type=template&id=0793955c"
import script from "./WorkloadPreApprove.vue?vue&type=script&lang=js"
export * from "./WorkloadPreApprove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__